// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2uYyL","options":"AnswerScale_options__3XztD","selected":"AnswerScale_selected__2QBBC"};